import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, message, Steps } from "antd";
import { ArrowLeft, FileText, MapPin, CircleCheck } from "lucide-react";
import { useSearchParams } from "react-router-dom";

import { MainWrapper } from "../../component/MainWrapper";
import { getUserDetails } from "sr/helpers/functions/getUserDetails";
import { getApplication } from "sr/utils/api/cleaner/getApplication";

import Step1 from "./step1";
import Step2 from "../create/step2";
import Step3 from "../create/step3";
import Step4 from "../create/step4";
import { getUserFullProfile } from "sr/utils/api/user/user";
import { LoaderFullScreen } from "sr/layout/common/LoaderFullScreen";

export function ContractorConvert() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { user_id } = getUserDetails();
  const id = searchParams.get("id");

  const [isLoading, setIsLoading] = useState(true);
  const [step, setStep] = useState(0);
  const [application, setApplication] = useState<any>({});
  const [stepData, setStepData] = useState<any>({});
  const [showOnboardingChecklist, setShowOnboardingChecklist] = useState(false);
  const [buttonLoader, setButtonLoader] = useState(true);

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    const loadProfile = async () => {
      const response = await getUserFullProfile();
      const profile = response?.data?.user_type_detail;
      setShowOnboardingChecklist(
        profile?.isAllowedOnBordingSubmission === true,
      );
      setButtonLoader(false);
    };
    loadProfile();
  }, []);

  const getData = async () => {
    try {
      const result = await getApplication(`id=${id}`);
      setApplication(result?.data);
      setIsLoading(false);
    } catch (err) {
      message.error("Something went wrong");
    }
  };

  const items = [
    {
      title: <div className="font-bold text-[16px]">Basic</div>,
      content: <div>Add basic information</div>,
      icon: (
        <div>
          <FileText />
        </div>
      ),
    },
    ...(showOnboardingChecklist
      ? [
          {
            title: (
              <div className="font-bold text-[16px]">Onboarding checklist</div>
            ),
            content: <div>Verify required onboarding items</div>,
            icon: <FileText />,
          },
        ]
      : []),
    {
      title: <div className="font-bold text-[16px]">Locations</div>,
      content: <div>Assign locations</div>,
      icon: (
        <div>
          <MapPin />
        </div>
      ),
    },
    {
      title: <div className="font-bold text-[16px]">Job Types</div>,
      content: <div>Assign job types</div>,
      icon: (
        <div>
          <CircleCheck />
        </div>
      ),
    },
  ];

  return (
    <MainWrapper>
      {buttonLoader && <LoaderFullScreen />}
      <div className="h-[92vh]">
        <div className="flex items-center flex-col sm:flex-row gap-4 border-b px-0 py-2">
          <div className="flex items-center gap-4 flex-1">
            <div>
              <Button className="!px-2" onClick={() => navigate(-1)}>
                <ArrowLeft size={20} />
              </Button>
            </div>
            <div className="font-bold text-lg">Convert To Contractor</div>
          </div>
          <div className="w-[350px] text-orange-900 text-[12px] bg-orange-100 p-1 px-2 rounded">
            Upon contractor convert, a verification email will be sent to the
            specified email address to validate the contractor’s details.
          </div>
        </div>
        <div className="mt-8 mx-auto max-w-4xl">
          <Steps
            type="default"
            size="small"
            variant="outlined"
            current={step}
            items={items}
          />
          {step === 0 && (
            <Step1
              company_id={user_id}
              isLoading={isLoading}
              application={application}
              data={stepData}
              onBack={() => navigate(-1)}
              onChange={(data: any) => {
                setStepData(data);
                setStep(1);
              }}
            />
          )}
          {((showOnboardingChecklist && step === 2) ||
            (!showOnboardingChecklist && step === 1)) && (
            <Step2
              company_id={user_id}
              data={stepData}
              onBack={() => setStep(showOnboardingChecklist ? 1 : 0)}
              onChange={() => setStep(showOnboardingChecklist ? 3 : 2)}
            />
          )}
          {showOnboardingChecklist && step === 1 && (
            <Step4
              data={stepData}
              onBack={() => setStep(0)}
              onChange={(data: any) => {
                setStepData(data);
                setStep(2);
              }}
            />
          )}
          {((showOnboardingChecklist && step === 3) ||
            (!showOnboardingChecklist && step === 2)) && (
            <Step3
              company_id={user_id}
              data={stepData}
              onBack={() => setStep(showOnboardingChecklist ? 2 : 1)}
              onChange={(data: any) => navigate(-1)}
            />
          )}
        </div>
      </div>
    </MainWrapper>
  );
}
